import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { GroupMenu } from './group-menu';
import { noop } from 'ts-essentials';
import { TreeContextProvider } from 'console/sortableDeviceTree/context';
import { TreeContext } from 'console/sortableDeviceTree/context/type';
import { useAnchor } from 'shared/hooks/utils';
import { createCustomTheme } from 'console/sortableDeviceTree/custom/custom-theme';
import { expandGroupInDeviceTree, moveItemInDeviceTree, } from 'console/redux/devices/tree/actions';
import { Tree } from 'console/sortableDeviceTree/tree';
import { itemIsGroup, } from 'console/sortableDeviceTree/utils/tree-type';
import { Typography } from '@mui/material';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { generateMongoDBId } from 'console/utils/mongo-db';
import { useAction } from 'shared/hooks/redux/hooks';
import { useKeybind } from 'console/left-menu/tree/model/use-keybind';
export const SortableDeviceTree = memo(function SortableDeviceTree(props) {
    const { search, are_filters_selected, ...rest } = props;
    return (_jsx(TreeContextProvider, { search: search, are_filters_selected: are_filters_selected, children: _jsx(SortableDeviceTreeImpl, { ...rest }) }));
});
export const SortableDeviceTreeImpl = memo(function SortableDeviceTreeImpl(props) {
    const { sizeOfNodes, drag_state, onSelectedDevice, can_manage_groups, can_manage_devices, ItemComponent, GroupComponent, } = props;
    const [path, setPath] = useState([]);
    const { selected_device_id, mathRandom, user_id, filteredTree, canDrag, selected_device_index, forceUpdate, } = useContext(TreeContext);
    const [menu_anchor, openMenu, closeMenu] = useAnchor();
    const [node, setNode] = useState({
        title: '',
        expanded: false,
        id: generateMongoDBId(),
        children: [],
        icon: '',
    });
    const [doScroll, noScroll, setDoScroll] = useBooleanState(true);
    const expandGroup = useAction(expandGroupInDeviceTree);
    const moveItem = useAction(moveItemInDeviceTree);
    const onExpandGroup = useCallback((data) => {
        forceUpdate();
        expandGroup(data.path, data.expanded);
    }, [expandGroup, selected_device_index]);
    const onMoveItem = useCallback((data) => moveItem(data.prevPath, data.nextPath, data.treeData), [moveItem]);
    const generateNodeProps = useCallback(() => ({
        rowWrapper: sizeOfNodes.rowWrapper,
        selected_device_id,
    }), [sizeOfNodes.rowWrapper, selected_device_id]);
    const renderItem = useCallback((props) => (_jsx(ItemComponent, { ...props, onSelectedDevice: onSelectedDevice, user_id: user_id, noScroll: noScroll })), [onSelectedDevice, noScroll, user_id]);
    const renderGroupItem = useCallback((props) => (_jsx(GroupComponent, { ...props, openMenu: openMenu, setNode: setNode, setPath: setPath, can_manage_devices: can_manage_devices, can_manage_groups: can_manage_groups })), [can_manage_devices, can_manage_groups]);
    const theme = useMemo(() => createCustomTheme(sizeOfNodes.lineBlock, true, renderItem, renderGroupItem), [sizeOfNodes.lineBlock, renderItem, renderGroupItem]);
    const _selected_device_index = useMemo(() => (doScroll ? selected_device_index : null), [selected_device_index, doScroll]);
    useEffect(() => {
        setDoScroll();
    }, [mathRandom]);
    const _filteredTree = useMemo(() => _selected_device_index != null
        ? _selected_device_index.new_tree
        : filteredTree, [_selected_device_index, filteredTree]);
    const onDragStateChanged = useCallback((data) => drag_state(data.isDragging), [drag_state]);
    const canDragItem = useCallback((params) => canDrag, [canDrag]);
    useKeybind();
    return (_jsxs(_Fragment, { children: [_filteredTree.length > 0 ? (_jsx(Tree, { treeData: _filteredTree, canDrag: canDragItem, onChange: noop, onVisibilityToggle: onExpandGroup, onMoveNode: onMoveItem, onDragStateChanged: onDragStateChanged, rowHeight: sizeOfNodes.heightNode, generateNodeProps: generateNodeProps, theme: theme, canNodeHaveChildren: itemIsGroup })) : (_jsx(Typography, { display: "flex", justifyContent: "center", color: "text.secondary", children: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" })), _jsx(GroupMenu, { anchor: menu_anchor, can_manage_devices: can_manage_devices, can_manage_groups: can_manage_groups, onClose: closeMenu, node: node, path: path })] }));
});
